import { registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, Injectable, LOCALE_ID } from '@angular/core';
import { LuxonDateAdapter, MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideDevstroupe } from '@devstroupe';
import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';
import { mockApiServices } from 'app/mock-api';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideEnvironmentNgxCurrency, NgxCurrencyInputMode } from 'ngx-currency';
import localePt from '@angular/common/locales/pt';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './core/custom-paginator';
import { Socket, SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { LIGHTBOX_CONFIG, LightboxConfig } from 'ng-gallery/lightbox';
import { register } from 'swiper/element/bundle';
const configSocket: SocketIoConfig = {
    options: { autoConnect: true, transports: ['websocket'], reconnection: true, reconnectionDelay: 1000, timeout: 5000, requestTimeout: 5000 },
    url: environment.apiUrlSocket,
};
const configSocket2: SocketIoConfig = {
    options: {
        autoConnect: true,
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 1000,
        timeout: 5000,
        requestTimeout: 5000,
    },
    url: environment.apiUrl.split('/').slice(0, 3).join('/'),
};
import { provideServiceWorker } from '@angular/service-worker';
import { provideToastr } from 'ngx-toastr';
import { provideEcharts } from 'ngx-echarts';
import { environment } from 'environments/environment';
import { ErrorImageDirective } from './shared/directives/erro-image.directive';
import { StorageKeysService } from './shared/services/storage-keys.service';
import { CompanyService } from './services/company.service';
import { MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { MtxLuxonDatetimeModule, MTX_LUXON_DATETIME_FORMATS } from '@ng-matero/extensions-luxon-adapter';
import { NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import {
    DATETIME_PICKER_PROVIDERS,
} from 'app/shared/datetime-picker/datetime-picker.imports';
register();
@Injectable()
export class SocketChatTroupe extends Socket {
    constructor() {
        super(configSocket);
    }
}

@Injectable()
export class SocketServer extends Socket {
    constructor() {
        super(configSocket2);
    }
}

@Injectable()
export class SocketCollector extends Socket {
    constructor() {
        super(configSocket);
    }
}

registerLocaleData(localePt, 'pt-BR');
export const MY_MTX_LUXON_FORMATS = {
    parse: {
        dateInput: 'dd/LL/yyyy HH:mm',
        timeInput: 'HH:mm',
        datetimeInput: 'dd/LL/yyyy HH:mm',
    },
    display: {
        dateInput: 'dd/LL/yyyy HH:mm',
        timeInput: 'HH:mm',
        datetimeInput: 'dd/LL/yyyy HH:mm',
        monthYearLabel: 'LLL yyyy',
        dateA11yLabel: 'dd/LL/yyyy',
        monthYearA11yLabel: 'LLLL yyyy',
        popupHeaderDateLabel: 'LLL dd, ccc',
    },
};
export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideHttpClient(),
        provideRouter(appRoutes, withPreloading(PreloadAllModules), withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
        importProvidersFrom(MtxLuxonDatetimeModule, NgxMatNativeDateModule),
        ...DATETIME_PICKER_PROVIDERS,
        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        { provide: MTX_DATETIME_FORMATS, useValue: MY_MTX_LUXON_FORMATS },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'D',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },
        // Transloco Config
        provideTransloco(),
        provideEcharts(),

        // Devstroupe
        provideAuth(),
        provideIcons(),
        provideDevstroupe({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            devstroupe: {
                layout: 'classic',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                    xxl: '1920px',
                },
                theme: 'theme-default',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
        provideEnvironmentNgxMask(),
        provideEnvironmentNgxCurrency({
            align: 'left',
            allowNegative: false,
            allowZero: true,
            decimal: ',',
            thousands: '.',
            precision: 2,
            prefix: 'R$ ',
            suffix: '',
            nullable: false,
            min: 0,
            max: null,
            inputMode: NgxCurrencyInputMode.Financial,
        }),
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR',
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'pt-BR',
        },
        // provideDateFnsDatetimeAdapter({
        //     parse: {
        //         dateInput: 'yyyy-MM-dd',
        //         yearInput: 'yyyy',
        //         monthInput: 'MMMM',
        //         datetimeInput: 'yyyy-MM-dd HH:mm',
        //         timeInput: 'HH:mm',
        //     },
        //     display: {
        //         dateInput: 'yyyy-MM-dd',
        //         yearInput: 'yyyy',
        //         monthInput: 'MMMM',
        //         datetimeInput: 'yyyy-MM-dd HH:mm',
        //         timeInput: 'HH:mm',
        //         monthYearLabel: 'yyyy MMMM',
        //         dateA11yLabel: 'LL',
        //         monthYearA11yLabel: 'MMMM yyyy',
        //         popupHeaderDateLabel: 'MMM dd, E',
        //     },
        // }),
        {
            provide: MatPaginatorIntl,
            useClass: CustomMatPaginatorIntl,
        },
        {
            provide: LIGHTBOX_CONFIG,
            useValue: {
                panelClass: 'mediaLigthbox',
            } as LightboxConfig,
        },

        SocketServer,
        { provide: 'SocketServer', useExisting: SocketServer },
        SocketChatTroupe,
        SocketCollector,
        { provide: 'SocketCollector', useExisting: SocketCollector },
        provideToastr(),
        provideServiceWorker('ngsw-worker.js', { enabled: environment.production }),

        { provide: StorageKeysService, useFactory: () => new StorageKeysService('ph') },
    ],
};
